import { createContext, useContext } from "react";

import type { ProductOptionI18nFormModel } from "../../model/type";

type QueryData = ProductOptionI18nFormModel["QueryData"];
type ViewModel = ProductOptionI18nFormModel["ViewModel"];

export type ProductOptionI18nFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;
};

export const ProductI18nOptionFormModelContext = createContext<ProductOptionI18nFormModelContextType | null>(null);

export const useProductOptionI18nFormModelContext = () => {
	const context = useContext(ProductI18nOptionFormModelContext);

	if (!context) {
		throw new Error(
			"useProductOptionI18nFormModelContext must be used within a ProductI18nOptionFormModelContext.Provider",
		);
	}

	return context;
};
